// EC計測モジュール（GA4 拡張Eコマース）
// テーマ側で view_* / add_to_cart を検知して Custom Pixel に publish する。
// Liquid からのデータ注入: window.__prtcEc.product / list / cart / locksmithDenied

(function () {
  const VIEW_CART_DEDUPE_WINDOW_MS = 10 * 1000;
  const ADD_TO_CART_REQUEST_DEDUPE_MS = 1500;
  const CART_ADD_URL_PATTERN = /\/cart\/add(?:\.js)?(?:[?#].*)?$/;

  let lastViewCartHash = '';
  let lastViewCartAt = 0;
  const recentAddToCartRequestKeys = new Map();

  install();

  function install() {
    installCartFetchHook();
    installCartXHRHook();
    installCartFormSubmitHook();

    bootInitialPublishes();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootInitialPublishes, { once: true });
    }
    window.addEventListener('pageshow', bootInitialPublishes);

    // カートドロワー開閉での view_cart 再発火検知
    document.addEventListener('click', onAnyClickForCartDrawer, true);
  }

  function bootInitialPublishes() {
    if (typeof window.sendGaIdsHint === 'function') {
      try { window.sendGaIdsHint(); } catch (e) { /* noop */ }
    }
    bootViewItem();
    bootViewItemList();
    bootViewCart();
  }

  function bootViewItem() {
    const ecData = window.__prtcEc;
    if (!ecData || !ecData.product) return;
    if (ecData.__viewItemPublished) return;
    ecData.__viewItemPublished = true;

    const base = { items: ecData.product.items || [] };
    if (ecData.product.currency) base.currency = ecData.product.currency;
    if (ecData.product.value != null) base.value = ecData.product.value;
    publishIfReady('view_item', decoratePayload(base));
  }

  function bootViewItemList() {
    const ecData = window.__prtcEc;
    if (!ecData || !ecData.list) return;
    if (ecData.__viewItemListPublished) return;
    ecData.__viewItemListPublished = true;

    publishIfReady('view_item_list', decoratePayload({
      item_list_id: ecData.list.item_list_id,
      item_list_name: ecData.list.item_list_name,
      items: ecData.list.items || []
    }));
  }

  function bootViewCart() {
    const ecData = window.__prtcEc;
    if (!ecData || !ecData.cart) return;

    const base = { items: ecData.cart.items || [] };
    if (ecData.cart.currency) base.currency = ecData.cart.currency;
    if (ecData.cart.value != null) base.value = ecData.cart.value;
    const payload = decoratePayload(base);

    const hash = JSON.stringify(payload.items || []);
    const now = Date.now();
    if (hash === lastViewCartHash && now - lastViewCartAt < VIEW_CART_DEDUPE_WINDOW_MS) {
      return;
    }
    lastViewCartHash = hash;
    lastViewCartAt = now;

    publishIfReady('view_cart', payload);
  }

  function onAnyClickForCartDrawer(e) {
    if (!e || !e.target) return;
    const opener = e.target.closest && e.target.closest('.Header_cart .CartIcon');
    if (!opener) return;
    // ドロワー DOM 更新を待ってから cart データを読みに行く
    setTimeout(bootViewCart, 300);
  }

  // /cart/add 一元フック（fetch / XHR / form submit）
  function installCartFetchHook() {
    if (window.__prtcEcFetchHooked) return;
    if (typeof window.fetch !== 'function') return;
    window.__prtcEcFetchHooked = true;

    const originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      const url = extractUrlFromFetchInput(input);
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const isCartAdd = method === 'POST' && url && CART_ADD_URL_PATTERN.test(url);

      const requestKey = isCartAdd ? buildRequestKeyFromFetch(input, init) : '';

      const promise = originalFetch(input, init);
      if (!isCartAdd) return promise;

      return promise.then(function (response) {
        if (!response || !response.ok) return response;
        if (requestKey && wasRecentRequest(requestKey)) return response;
        if (requestKey) markRecentRequest(requestKey);
        // レスポンスを clone してから読む（呼び出し元の消費を妨げない）
        try {
          response.clone().json().then(function (data) {
            fireAddToCartFromResponse(data);
          }).catch(function () { /* noop */ });
        } catch (e) { /* noop */ }
        return response;
      });
    };
  }

  function installCartXHRHook() {
    if (window.__prtcEcXHRHooked) return;
    if (typeof window.XMLHttpRequest !== 'function') return;
    window.__prtcEcXHRHooked = true;

    const OrigOpen = XMLHttpRequest.prototype.open;
    const OrigSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__prtcEcMethod = (method || '').toUpperCase();
      this.__prtcEcUrl = url || '';
      return OrigOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      const xhr = this;
      const isCartAdd = xhr.__prtcEcMethod === 'POST' && CART_ADD_URL_PATTERN.test(xhr.__prtcEcUrl || '');
      if (isCartAdd) {
        const requestKey = buildRequestKeyFromAny(xhr.__prtcEcUrl, body);
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          if (requestKey && wasRecentRequest(requestKey)) return;
          if (requestKey) markRecentRequest(requestKey);
          try {
            const data = JSON.parse(xhr.responseText);
            fireAddToCartFromResponse(data);
          } catch (e) { /* noop */ }
        });
      }
      return OrigSend.apply(this, arguments);
    };
  }

  function installCartFormSubmitHook() {
    if (window.__prtcEcSubmitHooked) return;
    window.__prtcEcSubmitHooked = true;

    document.addEventListener('submit', function (e) {
      const form = e && e.target;
      if (!form || !form.action) return;
      if (!CART_ADD_URL_PATTERN.test(form.action)) return;

      let formDataObj;
      try {
        formDataObj = serializeFormToObject(form);
      } catch (err) {
        return;
      }
      const requestKey = buildRequestKeyFromAny(form.action, formDataObj);
      if (requestKey && wasRecentRequest(requestKey)) return;
      if (requestKey) markRecentRequest(requestKey);

      // form submit はページ遷移を伴うため、form の内容から items を組み立てて即発火する
      const items = buildItemsFromFormDataObject(formDataObj);
      if (!items.length) return;
      fireAddToCart(items);
    }, true);
  }

  function fireAddToCartFromResponse(data) {
    if (!data) return;
    // Shopify /cart/add.js は単一商品 or { items:[...] } の両形式
    const items = [];
    if (Array.isArray(data.items)) {
      data.items.forEach(function (it) { items.push(buildItemFromLine(it)); });
    } else if (data.id) {
      items.push(buildItemFromLine(data));
    }
    if (!items.length) return;
    fireAddToCart(items);
  }

  function fireAddToCart(items) {
    const currency = guessCurrency();
    const value = items.reduce(function (sum, it) {
      const p = Number(it.price) || 0;
      const q = Number(it.quantity) || 1;
      return sum + p * q;
    }, 0);

    // cart.attributes への client_id 書込（hybrid 第1経路）
    if (typeof window.ensureCartGaClientId === 'function') {
      try { window.ensureCartGaClientId(); } catch (e) { /* noop */ }
    }

    const base = { value: round2(value), items: items };
    if (currency) base.currency = currency;
    publishIfReady('add_to_cart', decoratePayload(base));
  }

  function buildItemFromLine(line) {
    // /cart/add.js のレスポンス 1要素 or cart.js の line_item
    // price は銭単位、presentment_price は通貨単位（円/ドル等の文字列または数値）
    let price = 0;
    if (typeof line.presentment_price === 'number') {
      price = line.presentment_price;
    } else if (typeof line.presentment_price === 'string') {
      price = parseFloat(line.presentment_price) || 0;
    } else if (typeof line.price === 'number') {
      price = line.price / 100;
    }

    return {
      item_id: String(line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      item_variant: line.variant_title || '',
      price: round2(price),
      quantity: Number(line.quantity) || 1
    };
  }

  function buildItemsFromFormDataObject(obj) {
    // /cart/add の form は通常 id（variant_id） / quantity / properties[*] のフラット形式
    // 複数商品送信は { items: [...] } 形式だが、form での複数送信は稀。最小サポート。
    if (!obj) return [];

    if (obj.id) {
      return [{
        item_id: String(obj.id),
        item_name: '',
        item_brand: '',
        item_category: '',
        item_variant: '',
        price: 0,
        quantity: Number(obj.quantity) || 1
      }];
    }
    return [];
  }

  function serializeFormToObject(form) {
    const fd = new FormData(form);
    const obj = {};
    fd.forEach(function (value, key) {
      obj[key] = value;
    });
    return obj;
  }

  function decoratePayload(payload) {
    const userId = (typeof getHoloAccountUserId === 'function') ? (getHoloAccountUserId() || null) : null;
    const out = Object.assign({}, payload || {});
    out.user_id = userId;
    out.page_location = location.href;
    out.page_referrer = document.referrer || '';
    return out;
  }

  function publishIfReady(eventName, payload) {
    if (typeof window.publishEcAnalyticsEvent === 'function') {
      window.publishEcAnalyticsEvent(eventName, payload);
    }
  }

  function guessCurrency() {
    const ecData = window.__prtcEc || {};
    if (ecData.cart && ecData.cart.currency) return ecData.cart.currency;
    if (ecData.product && ecData.product.currency) return ecData.product.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return null;
  }

  function round2(n) {
    return Math.round(Number(n || 0) * 100) / 100;
  }

  function extractUrlFromFetchInput(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function buildRequestKeyFromFetch(input, init) {
    const url = extractUrlFromFetchInput(input);
    const body = (init && init.body) || '';
    return buildRequestKeyFromAny(url, body);
  }

  function buildRequestKeyFromAny(url, body) {
    try {
      let bodyKey = '';
      if (typeof body === 'string') {
        bodyKey = body;
      } else if (body && typeof body === 'object') {
        // FormData / Object どちらでも JSON 化
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
          const obj = {};
          body.forEach(function (v, k) { obj[k] = v; });
          bodyKey = JSON.stringify(obj);
        } else {
          bodyKey = JSON.stringify(body);
        }
      }
      return (url || '') + '::' + bodyKey;
    } catch (e) {
      return '';
    }
  }

  function wasRecentRequest(key) {
    if (!key) return false;
    pruneRecentRequests();
    return recentAddToCartRequestKeys.has(key);
  }

  function markRecentRequest(key) {
    if (!key) return;
    recentAddToCartRequestKeys.set(key, Date.now());
    pruneRecentRequests();
  }

  function pruneRecentRequests() {
    const now = Date.now();
    recentAddToCartRequestKeys.forEach(function (ts, k) {
      if (now - ts > ADD_TO_CART_REQUEST_DEDUPE_MS) {
        recentAddToCartRequestKeys.delete(k);
      }
    });
  }
})();
